/* function getSousTotal(counts, grades) {
  return grades.reduce((total, grade) => total + (counts[grade] || 0), 0);
}

function getTotalGeneral(counts) {
  return Object.values(counts).reduce((total, count) => total + count, 0);
} */
import React, { useEffect, useState } from 'react';
import axios from '../helpers/axiosConfig';
import { toast } from 'react-toastify';
import '../App.css';
const EffectifNouriOperationnel = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    toast.info('Tableau des personnels en opération en cours');
    axios
      .get('/personnel/stat/operationnels/2')
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => toast.error(error.response.data.error));
  }, []);

  return (
    <div className=" mt-5 container " style={{ fontSize: 14 }}>
      <div className="bg-warning">
        <h2>Tableau des personnels en opération</h2>
      </div>
      <div className="d-flex justify-content-center ">
        <table className="table table-striped table-sm" border="1">
          <thead className="thead-dark">
            <tr>
              <th>Zone de défense</th>
              <th>Corps</th>
              <th>GCA</th>
              <th>GDI</th>
              <th>GBR</th>
              <th>COL</th>
              <th>LCL</th>
              <th>CDT</th>
              <th>CNE</th>
              <th>LTN</th>
              <th>SLT</th>
              <th className="vertical-header">SousTotalOff</th>
              <th>AMJ</th>
              <th>ADC</th>
              <th>ADJ</th>
              <th>SGM</th>
              <th>SGT</th>
              <th className="vertical-header">SousTotalSOff</th>
              <th>CAC</th>
              <th>CAL</th>
              <th>S1C</th>
              <th>S2C</th>
              <th className="vertical-header">SousTotalADL</th>
              <th>S1C</th>
              <th>S2C</th>
              <th className="vertical-header">SousTotalPDL</th>
              <th className="vertical-header">Total Général</th>
            </tr>
          </thead>
          <tbody>
            {data.map((zone, zoneIndex) => (
              <React.Fragment key={zoneIndex}>
                {zone.boadss.map((boadss, boadssIndex) => (
                  <tr key={boadssIndex}>
                    <td>{zone.zonededefense}</td>
                    <td>{boadss.corps}</td>
                    <td>{boadss.grades.OFF.GCA}</td>
                    <td>{boadss.grades.OFF.GDI}</td>
                    <td>{boadss.grades.OFF.GBR}</td>
                    <td>{boadss.grades.OFF.COL}</td>
                    <td>{boadss.grades.OFF.LCL}</td>
                    <td>{boadss.grades.OFF.CDT}</td>
                    <td>{boadss.grades.OFF.CNE}</td>
                    <td>{boadss.grades.OFF.LTN}</td>
                    <td>{boadss.grades.OFF.SLT}</td>
                    <td className="bg-info">{boadss.sousTotaux.sousTotalOff}</td>

                    <td>{boadss.grades['S-OFF'].AMJ}</td>
                    <td>{boadss.grades['S-OFF'].ADC}</td>
                    <td>{boadss.grades['S-OFF'].ADJ}</td>
                    <td>{boadss.grades['S-OFF'].SGM}</td>
                    <td>{boadss.grades['S-OFF'].SGT}</td>
                    <td className="bg-info">{boadss.sousTotaux.sousTotalSOff}</td>

                    <td>{boadss.grades.ADL.CAC}</td>
                    <td>{boadss.grades.ADL.CAL}</td>
                    <td>{boadss.grades.ADL.S1C}</td>
                    <td>{boadss.grades.ADL.S2C}</td>
                    <td className="bg-info">{boadss.sousTotaux.sousTotalAdl}</td>

                    <td>{boadss.grades.PDL.S1C}</td>
                    <td>{boadss.grades.PDL.S2C}</td>
                    <td className="bg-info">{boadss.sousTotaux.sousTotalPdl}</td>

                    <td className="bg-danger">{boadss.sousTotaux.totalGeneral}</td>
                  </tr>
                ))}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default EffectifNouriOperationnel;
